/**
 * Grab bag of helper utility functions
 */

/**
 * Helper function "normalizes" a string by removing all non alpha-numeric characters and lowercasing, which
 * puts it in format better suited for searching and sorting in firestore.
 *
 * @param aString The string to normalize
 * @return A string with non-alphanumeric characters removed, and lower cased.
 */
function normalizeString(aString) {
  if (!aString) {
    return aString;
  }

  return aString.replace(/\W/g, '').toLowerCase();
}

module.exports = {
  normalizeString
};